import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexColumn, FlexRow, IconButton } from "@similarweb/ui-components";

import { DROPDOWN_CONFIG } from "app/pages/activation/components/Topics/Dropdown/config";

const { carbon } = colorsPalettes;

export const StyledIconButton = styled(IconButton)`
    & svg {
        width: 10px;
        height: 10px;
    }

    .SWReactIcons {
        display: flex;
        align-items: center;
        justify-content: center;
    }
`;

StyledIconButton.displayName = "StyledIconButton";

export const DropdownItemWrapper = styled(FlexRow)`
    align-items: start;
    gap: 6px;
    padding: 12px 16px;
    cursor: pointer;

    &:hover {
        background-color: ${carbon[25]};
    }
`;

DropdownItemWrapper.displayName = "DropdownItemWrapper";

export const ItemTextWrapper = styled(FlexColumn)`
    gap: 6px;
    max-width: ${DROPDOWN_CONFIG.width}px;
`;

ItemTextWrapper.displayName = "ItemTextWrapper";

export const ItemTitle = styled.h2`
    margin: 0;
    ${setFontVariant("input2", carbon[500])};
`;

ItemTitle.displayName = "ItemTitle";

export const ItemDescription = styled.p`
    margin: 0;
    ${setFontVariant("listItem3", carbon[300])};
`;

ItemDescription.displayName = "ItemDescription";
